module.exports = __webpack_public_path__ + "static/media/industries-carbon-paste-s.294f020b.webp";